(function (app, ng) {
    app.constant("responseStatus",
        {
            Nothing: { value: 1, description: "" },
            Processing: { value: 2, description: "Saving..." },
            Saved: { value: 3, description: "Saved" },
            Failed: { value: 4, description: "Failed" },
            Invalid: { value: 5, description: "Not saved" },
            Typing: { value: 6, description: "Typing" }

        });
})(window.app, window.angular);